var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pie-wrapper"
  }, [_c("a-row", {
    staticClass: "pie-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("爱吃食物分类"),
      hoverable: true,
      bordered: false
    }
  }, [_c("hollow-pie", {
    staticClass: "chart-line"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("技术占比"),
      hoverable: true,
      bordered: false
    }
  }, [_c("solid-pie", {
    staticClass: "chart-line"
  })], 1)], 1)], 1), _c("a-row", {
    staticClass: "pie-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("衣服开销"),
      hoverable: true,
      bordered: false
    }
  }, [_c("radius-pie", {
    staticClass: "chart-line"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("环状图"),
      hoverable: true,
      bordered: false
    }
  }, [_c("annular-pie", {
    staticClass: "chart-line"
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };